import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  licenseplateFrom:"",
  licenseplateTo:"",
  taraFrom:"",
  taraTo:"",
  pmaFrom:"",
  pmaTo:"",
  checkpma:true,
  notcheckpma:true,
  defaultdriverFrom:"",
	defaultdriverTo:"",
  vehicleStoreFrom:"",
  vehicleStoreTo:"",
  enabled:true,
  notenabled:true 
};

const filtersVehiclesSlice = createSlice({
  name: 'filtersVehicles',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersVehiclesSlice.actions;
export default filtersVehiclesSlice.reducer;
